import { arrayOfProjectTemplateElements, projectTemplateElement } from "~/schemas/schema.project_template_elements.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchProjectTemplateElements = (projectTemplateId) => {
  const url = `${Angie.api_url}/project-templates/${projectTemplateId}/elements`;
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENTS_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url,
      }),
    payload: {
      projectTemplateId,
      schema: arrayOfProjectTemplateElements,
    },
    cache: {
      key: url,
    },
  };
};

export const fetchProjectTemplateElement = (projectTemplateId, elementId) => {
  const url = `${Angie.api_url}/project-templates/${projectTemplateId}/elements/${elementId}`;
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENT_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url,
      }),
    payload: {
      projectTemplateId,
      elementId,
      schema: {
        single: projectTemplateElement,
      },
    },
    cache: {
      key: url,
    },
  };
};

export const deleteProjectTemplateElement = (id, template_id, elementType) => {
  return {
    types: [
      actionTypes.DELETE_PROJECT_TEMPLATE_ELEMENT_LOADING,
      actionTypes.DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
      actionTypes.DELETE_PROJECT_TEMPLATE_ELEMENT_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/elements/${id}`,
        method: `DELETE`,
      }),
    payload: {
      template_id,
      id,
      elementType,
    },
  };
};

export const editProjectTemplateElement = (id, template_id, data) => {
  return {
    types: [
      actionTypes.EDIT_PROJECT_TEMPLATE_ELEMENT_LOADING,
      actionTypes.EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
      actionTypes.EDIT_PROJECT_TEMPLATE_ELEMENT_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/elements/${id}`,
        method: `PUT`,
        body: data,
      }),
    payload: {
      template_id,
      id,
      data,
      schema: {
        single: projectTemplateElement,
      },
    },
  };
};

export const moveToListProjectTemplateTask = (
  id,
  template_id,
  new_task_list_id,
  previous_task_list_id,
  new_position,
  previous_position,
  data
) => {
  return {
    types: [
      actionTypes.MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_LOADING,
      actionTypes.MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_SUCCESS,
      actionTypes.MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/elements/${id}`,
        method: `PUT`,
        body: data,
      }),
    payload: {
      template_id,
      id,
      data,
      sourceTaskListId: previous_task_list_id,
      targetTaskListId: new_task_list_id,
      newPosition: new_position,
      prevPosition: previous_position,
      schema: {
        single: projectTemplateElement,
      },
    },
  };
};

export const reorderProjectTemplateElements = (template_id, order) => {
  return {
    types: [
      actionTypes.REORDER_PROJECT_TEMPLATE_ELEMENTS_LOADING,
      actionTypes.REORDER_PROJECT_TEMPLATE_ELEMENTS_SUCCESS,
      actionTypes.REORDER_PROJECT_TEMPLATE_ELEMENTS_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/reorder`,
        method: `PUT`,
        body: order,
      }),
    payload: {
      order,
    },
  };
};

export const addProjectTemplateElement = (template_id, data) => {
  return {
    types: [
      actionTypes.ADD_PROJECT_TEMPLATE_ELEMENT_LOADING,
      actionTypes.ADD_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
      actionTypes.ADD_PROJECT_TEMPLATE_ELEMENT_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/elements`,
        method: `POST`,
        body: data,
      }),
    payload: {
      template_id,
      data,
      schema: {
        single: projectTemplateElement,
      },
    },
  };
};

export const batchAddProjectTemplateFiles = (template_id, data = []) => {
  return {
    types: [
      actionTypes.BATCH_ADD_PROJECT_TEMPLATE_FILES_LOADING,
      actionTypes.BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS,
      actionTypes.BATCH_ADD_PROJECT_TEMPLATE_FILES_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/${template_id}/elements/batch`,
        method: `POST`,
        body: data,
      }),
    payload: {
      template_id,
      data,
      schema: arrayOfProjectTemplateElements,
    },
  };
};

export const unassignClientFromProjectTemplateSubtasks = (subtaskIds) => {
  return {
    type: actionTypes.UNASSIGN_CLIENT_FROM_PROJECT_TEMPLATE_SUBTASKS,
    subtaskIds,
  };
};
